import { render, staticRenderFns } from "./game-filter.vue?vue&type=template&id=ba52090e&scoped=true"
import script from "./game-filter.vue?vue&type=script&lang=js"
export * from "./game-filter.vue?vue&type=script&lang=js"
import style0 from "./game-filter.vue?vue&type=style&index=0&id=ba52090e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba52090e",
  null
  
)

export default component.exports